export enum AnswersQuizEnum {
  'A',
  'B',
  'C',
  'D',
}
